<script>
    import LikesItem from "./LikesItem.svelte";
    import ViewPhotoModal from "./ViewPhotoModal.svelte";
    import MissingData from "./MissingData.svelte";
    import {loadLikes} from "../lib/ApiRequests.svelte";
    import {onMount} from "svelte";
    import ViewVideoModal from "./ViewVideoModal.svelte";
    import {_} from '../lib/i18n';
    import {Constans} from "../lib/Constants";
    import FreeAccessDataHiddenAlert from "./FreeAccessDataHiddenAlert.svelte";
    import {navigate} from "svelte-routing";

    export let analyze;
    export let path;
    export let date;
    export let params;

    let items = [];
    $: analyze && (items = (analyze.result && analyze.result.likes)  ? analyze.result.likes : []);

    let isTemporary;
    $: isTemporary = (analyze && analyze.temporary ? true : false);

    let progress = 0;
    $: progress = analyze ? analyze.likesProgress : 0;
    let mounted = false;
    $: progress && mounted && initialLoad();

    onMount(async () => {
        mounted = true;
    });

    function gotoTariffs() {
        navigate(`${path}/dashboard/subscription`);
    }

    const counterIncValue = 10;

    let isLoading = false;
    async function initialLoad() {
        if (progress < 100 || isLoading || items.length > 0) return;

        isLoading = true;
        try {
            const response = await loadLikes(analyze.id, counterIncValue, 0, 1, 3, 1, date);
            analyze.setResults('likes', response.data);
        } catch (err) {
            console.error(err);
        }
        isLoading = false;
    }


    let showCounter = params.identity.isEnabledFreeTrial() ? 5 : 10;
    let showShowMore = false;
    $: items && (showShowMore = items.length > showCounter);
    let filteredItems = [];
    function filterItems() {
        filteredItems = [...items];
        filteredItems.sort((a, b) => {
            if ( (a.to.length + a.from.length) < (b.to.length + b.from.length) ){
                return 1;
            }
            if ( (a.to.length + a.from.length) > (b.to.length + b.from.length) ){
                return -1;
            }
            return 0;
        });
        filteredItems = filteredItems.splice(0, showCounter);
    }

    function showMore() {
        if (params.identity.isEnabledFreeTrial()) {
            gotoTariffs();
        }
        showCounter += counterIncValue;
        if (showCounter > items.length) {
            showCounter = items.length;
            showShowMore = false;
        }
    }

    $: (analyze || items || showCounter) && filterItems();

    let selectedMedia = {};

    function selectMedia(item) {
        selectedMedia = item;
    }

    let showPhotoModal = false;
    let showVideoModal = false;

    let selectedImageUrl;
    $: selectedMedia && (selectedImageUrl = selectedMedia.image);
    let selectedImageLink;
    $: selectedMedia && (selectedImageLink = `https://instagram.com/p/${selectedMedia.code}`);
    let selectedMediaCreatedAt;
    $: selectedMedia && (selectedMediaCreatedAt = new Date(selectedMedia.created_at * 1000));

    let selectedVideoUrl;
    $: selectedMedia && (selectedVideoUrl = `/instashpion/media/cached-media?id=${selectedMedia.id}`);

    let isEnabledFreeTrial = false;
    $: isEnabledFreeTrial = (params && params.identity) ? params.identity.isEnabledFreeTrial() : false;

</script>

{#if !isTemporary}
    {#if items.length > 0}
        {#each filteredItems as item, index}
            <LikesItem {analyze} rating={index + 1} {item} {selectMedia} {params}
                       bind:showPhotoModal={showPhotoModal}
                       bind:showVideoModal={showVideoModal}
            />
        {/each}

        {#if showShowMore}
            <button class="button button_ghost feed-content__load-more-btn" on:click={showMore}>{$_('likesResult.loadMore')}</button>
        {/if}
    {:else}
        <MissingData {analyze} {path} analyzeInProgress={progress != 100} category="likes" />
    {/if}
{/if}


    <ViewPhotoModal imageUrl={selectedImageUrl}
                    instagramLink={selectedImageLink}
                    imageCreatedAt={selectedMediaCreatedAt}
                    type={Constans.typeHeaders.LIKE}
                    bind:show={showPhotoModal}
    />

    <ViewVideoModal instagramLink={selectedImageLink}
                    videoCreatedAt={selectedMediaCreatedAt}
                    videoUrl={selectedVideoUrl}
                    type={Constans.typeHeaders.LIKE}
                    bind:show={showVideoModal}
    />


<style>

</style>